import { createPortal } from 'react-dom';
import {

  ModalContent,
  ModalOverlay,
  CloseBtn,
} from './ModalMessage.styled';
import { useRef } from 'react';


const ModalMessage = ({ children, onClose, pad,hug=false }) => {
  const handleContentClick = event => {
    event.stopPropagation();
  };
 const shouldClose = useRef(false);

  const handleMouseDown = (e) => {
    shouldClose.current = e.target === e.currentTarget;
  };
 const handleMouseUp = (e) => {
    if (
      shouldClose.current &&
      e.target === e.currentTarget
    ) {
      onClose();
    }

    shouldClose.current = false;
  };


  return <ModalOverlay   onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}>
    <ModalContent className={ hug?'hug':''} pad={pad} onClick={handleContentClick}>

      {pad !== "false" && <CloseBtn onClick={onClose} />}

      {children}
    </ModalContent>
  </ModalOverlay >


};

export default ModalMessage;
